import { Component, ViewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ModalService } from '../../modal/modal.service';
import { TopBarGamesComponent } from '../top-bar-games/top-bar-games.component';
import { TopBarNavigationComponent } from '../top-bar-navigation/top-bar-navigation.component';
import { environment } from '@env/environment';
import { NavigationService } from '@features/navigation/navigation.service';
import { BALANCE_LABELS, SELECTABLE_BALANCE_TYPES, SelectableBalanceType } from '@models/balance.interface';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { ToggleDropdownDirective } from '@shared/directives/toggle-dropdown.directive';
import { DropdownItemComponent } from '@shared/dropdown/dropdown-item.component';
import { DropdownComponent as DropdownComponent_1, DropdownComponent } from '@shared/dropdown/dropdown.component';
import { IconComponent } from '@shared/icon/icon.component';
import { LevelNewComponent } from '@shared/level-new/level-new.component';
import { SessionService } from '@shared/session.service';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
  imports: [
    RouterLink,
    IconComponent,
    TopBarGamesComponent,
    ToggleDropdownDirective,
    CurrencyComponent,
    DropdownComponent_1,
    DropdownItemComponent,
    LevelNewComponent,
    RouterLinkActive,
    TopBarNavigationComponent,
  ],
})
export class TopBarComponent {
  @ViewChild('dropdown') dropdown: DropdownComponent;
  cdnBase = environment.cdnBase;

  readonly balanceTypes = SELECTABLE_BALANCE_TYPES;
  readonly balanceLabels = BALANCE_LABELS;

  isHomeHovered = false;

  constructor(public uiService: UIService, public navigationService: NavigationService, public session: SessionService, private modalService: ModalService) {}

  onHomeMouseEnter() {
    this.isHomeHovered = true;
  }

  onHomeMouseLeave() {
    this.isHomeHovered = false;
  }

  selectBalanceType(type: SelectableBalanceType) {
    this.session.changeBalanceType(type);
  }

  handleOpenUserMenu() {
    if (!this.session.profile()) {
      return;
    }

    this.dropdown.toggle(this.dropdown.element.nativeElement);
  }
}
